import { render, staticRenderFns } from "./ModalEditItemGroup.vue?vue&type=template&id=18a4b14c&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ModalEditItemGroup.vue?vue&type=script&lang=js&"
export * from "./ModalEditItemGroup.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditItemGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4b14c",
  null
  
)

export default component.exports